<template>
  <el-container class="f-h center">
    <el-row type="flex" justify="center" align="middle" class="f-h f-w">
      <div v-if="!errMsg" >
        <img v-if="theme && theme.loadingImgFile" :src="theme.loadingImgFile" />
        <h2>正在加载，请稍后…</h2>
      </div>
      <div v-else >
        <img v-if="theme && theme.errImgFile" :src="theme.errImgFile" />
        <h2 class="danger">{{ errMsg }}</h2>
      </div>
    </el-row>
  </el-container>
</template>

<script>
  import { mapGetters } from "sw-hic";
  import api from "@/common/api";
  export default {
    data() {
      return {
        showEditor: false,
        entity: null,
        errMsg: null,
        readonly: false,
      };
    },
    computed: {
      ...mapGetters(["token", "theme", "dict"]),
    },
    async mounted() {
      if (this.$route.query.usr && this.$route.query.pwd && this.$route.query.tenant) {
        // 必须清空token，因为后端接口只要有token就会验证token，这时候会401，spring自动验证的，导致走不到登录逻辑
        this.$store.commit("token", null)
        try {
          let res = null;
          if (this.$route.query.timeStamp) {
            this.$utils.log("MD5登录");
            res = await api.Server.md5Token(this.$route.query.usr, this.$route.query.pwd, this.$route.query.tenant, this.$route.query.timeStamp);
          } else {
            this.$utils.log("密码登录");
            res = await api.Server.pwdToken(this.$route.query.usr, this.$route.query.pwd, this.$route.query.tenant);
          }
          this.$utils.log(res);
          if (!res?.access_token) {
            this.$utils.goErr(this.$cfg.errs.NeedPromission);
            throw new Error("抱歉，您没有权限访问此系统！");
          }
          this.$utils.saveToken(res);
          this.$store.dispatch("init");
          await setTimeout(() => {}, 1000);

          this.$utils.log("获取用户");
          const usr = await api.User.get();
          this.$utils.log(usr);

          this.$store.commit("user", usr);
          this.$utils.log("获取权限");
          const ps = await api.User.queryPermission();
          this.$utils.log(ps);
          if (!ps.length) {
            this.$utils.goErr(this.$cfg.errs.NeedPromission);
            throw new Error("抱歉，您没有权限访问此系统！");
          }
          this.$store.commit("permission", ps);
          this.$store.dispatch("loaders");
        } catch (error) {
          this.$utils.log(error);
          this.showErr("登录失败！");
          return;
        }
      }
      if (!this.token) {
        this.showErr("当前用户尚未登录！");
        return;
      }
      while (!this.dict?.MrElement?.length) {
        this.$utils.log("等待字典MrElement加载");
        await this.$utils.wait(1000);
      }
      this.$utils.log("登录成功，开始跳转");
      let opNo = this.$route.query.op;
      if (!opNo && this.$route.query.patient) {
        let res = await api.Treatment.query({
            patientCode: this.$route.query.patient,
            sort: "id",
            asc: false,
            pageSize: 1,
            pageIndexOnView: 1,
          })
        if (res.items.length) {
          opNo = res.items[0].opNo
        } else {
          this.showErr("未找到患者的就诊记录！")
          return
        }
      }
      if (!opNo) {
        this.showErr("缺少就诊号参数！");
      }
      if (this.$route.name == "view") {
        this.$router.replace({
          name: "viewer",
          query: { op: opNo },
        });
      } else {
        this.$router.replace({
          name: "editor",
          query: { op: opNo, readonly: this.$route.query.readonly },
        });
      }
    },
    methods: {
      showErr(err) {
        this.$message.error(err);
        this.errMsg = err;
      },
    },
  };
</script>
